const U = (id, w = 1200) =>
  `https://images.unsplash.com/${id}?auto=format&fit=crop&w=${w}&q=70`;

const P = (id) =>
  `https://images.pexels.com/photos/${id}/pexels-photo-${id}.jpeg?auto=compress&cs=tinysrgb&w=1200`;

export const IMAGES = {
  hero: "/assets/hero-aurora.jpg",
  aurora: U("photo-1483347756197-71ef80e95f73"),
  iceCaveAlt:
    "https://images.pexels.com/photos/11711904/pexels-photo-11711904.jpeg?auto=compress&cs=tinysrgb&w=1200",
  dining: U("photo-1414235077428-338989a2e8c0"),
};

export const SERVICES = [
  {
    id: "hotels",
    name: "Five-Star Hotels & Luxury Villas",
    tag: "Sanctuary",
    desc: "Suites at The Retreat at Blue Lagoon, The Reykjavik EDITION, and private villas framed by lava fields.",
    image:
      "https://images.ctfassets.net/w65k7w0nsb8q/2L6UyboQzM26lViMRD2R0X/15da35923923965cbe8996f2af785f0c/The_Retreat.jpg?w=1600&q=75&fm=jpg",
  },
  {
    id: "transport",
    name: "Luxury Transfers and Chauffeuring",
    tag: "Seamless",
    desc: "Chauffeured Range Rovers, Mercedes V-Class fleets and airport meet-and-greet on landing.",
    image: U("photo-1449965408869-eaa3f722e40d"),
  },
  {
    id: "helicopter",
    name: "Private Helicopter Tours",
    tag: "Altitude",
    desc: "Glacier landings, volcano overflights and champagne on a black-sand summit.",
    image: "/assets/catalogue/helicopter-iceland.jpg",
  },
  {
    id: "superjeep",
    name: "Monster Truck Excursions",
    tag: "Terrain",
    desc: "Modified 44-inch monsters across highlands, rivers and ridgelines no road reaches.",
    image: "/assets/catalogue/monster-truck.jpg",
  },
  {
    id: "monstertrucks",
    name: "Super-Jeep Rallies",
    tag: "Horsepower",
    desc: "Converted mountain Land Cruisers in convoy across the glaciers — full rally crew, support and safety.",
    image:
      "https://images.pexels.com/photos/4581178/pexels-photo-4581178.jpeg?auto=compress&cs=tinysrgb&w=1200",
  },
  {
    id: "snowmobile",
    name: "Snowmobile Glacier Runs",
    tag: "Action",
    desc: "Full-throttle runs across Langjökull's ice cap — private guides, heated gear and summit photo stops.",
    image: P(804569),
  },
  {
    id: "atv",
    name: "ATV & Buggy Adventures",
    tag: "Action",
    desc: "Black-sand beaches, lava tracks and river crossings on private quad and buggy convoys.",
    image: "/assets/catalogue/buggy-black-sand.jpg",
  },
  {
    id: "icecaves",
    name: "Ice Cave Soirées",
    tag: "Sub-Zero",
    desc: "Private dinners and DJ sets inside sapphire glacier caves, lit only by ice and candlelight.",
    image:
      "https://images.pexels.com/photos/10130133/pexels-photo-10130133.jpeg?auto=compress&cs=tinysrgb&w=1200",
  },
  {
    id: "lavacaves",
    name: "Lava Cave Galas",
    tag: "Subterranean",
    desc: "Full-scale parties staged in volcanic chambers — sound, light, bar and fire.",
    image: U("photo-1619266465172-02a857c3556d"),
  },
  {
    id: "hotsprings",
    name: "Geothermal Hot Springs",
    tag: "Ritual",
    desc: "After-hours lagoon buyouts and secret springs under the northern lights.",
    image: "/assets/catalogue/blue-lagoon-spa.jpg",
  },
  {
    id: "chefs",
    name: "Private Chefs & Fine Dining",
    tag: "Palate",
    desc: "Nordic tasting menus cooked tableside — in your villa, or inside the ice tunnels of Langjökull.",
    image: "/assets/catalogue/ice-cave-dinner.jpg",
  },
  {
    id: "nightlife",
    name: "VIP Nightlife & Bottle Service",
    tag: "After Dark",
    desc: "Front-of-line entry, hosted tables and rare bottles across Reykjavik's best rooms.",
    image: "/assets/catalogue/vip-bottle-service.jpg",
  },
  {
    id: "festivals",
    name: "Secret Festivals & Events",
    tag: "Gathering",
    desc: "Access to invitation-only gatherings, midnight-sun festivals and private stages.",
    image: "/assets/tours/immersion-festival.jpg",
  },
  {
    id: "supercars",
    name: "Supercar Rallies",
    tag: "Worldwide",
    desc: "Lamborghinis and Ferraris across volcanic ring roads or coastal rivieras — full rally support crew.",
    image: U("photo-1503376780353-7e6692767b70"),
  },
  {
    id: "jets",
    name: "Private Jet Rentals",
    tag: "Worldwide",
    desc: "Chartered Gulfstreams and Globals into Keflavík — or wheels-up from anywhere on Earth.",
    image: U("photo-1540962351504-03099e0a754b"),
  },
  {
    id: "villas",
    name: "Villas, Mansions & Estates",
    tag: "Worldwide",
    desc: "Glass-walled villas, countryside manors and fully staffed estates across Iceland and beyond.",
    image: U("photo-1613490493576-7fde63acd811"),
  },
  {
    id: "islands",
    name: "Private Islands",
    tag: "Worldwide",
    desc: "Entire islands, exclusively yours — arrival by helicopter or yacht, staff and chefs included.",
    image: U("photo-1573843981267-be1999ff37cd"),
  },
  {
    id: "yacht",
    name: "Yacht & Ocean Charters",
    tag: "Worldwide",
    desc: "Crewed yachts through fjords, whale routes and island anchorages.",
    image: U("photo-1548574505-5e239809ee19"),
  },
  {
    id: "worldwide",
    name: "Worldwide Private Events",
    tag: "Worldwide",
    desc: "The same key opens doors on every continent — celebrations planned globally.",
    image: U("photo-1511795409834-ef04bbd61622"),
  },
];

// Geothermal Hot Springs sub-picker — opened from the main "Geothermal Hot
// Springs" catalogue card (all regions), the Reykjavík-area card in Activities
// from Reykjavik (capital only), and the card in Activities beyond the capital
// (the rest). Clients multi-select as many as they like.
export const HOT_SPRING_REGIONS = [
  { key: "reykjavik", label: "Reykjavík Area" },
  { key: "south", label: "South Coast" },
  { key: "west", label: "West Iceland" },
  { key: "snaefellsnes", label: "Snæfellsnes" },
  { key: "westfjords", label: "The Westfjords" },
  { key: "north", label: "The North" },
  { key: "east", label: "East Fjords" },
];

export const HOT_SPRINGS = [
  // Reykjavík area
  { id: "hs-blue-lagoon-retreat", name: "The Blue Lagoon Retreat Spa", area: "reykjavik", blurb: "The lagoon's most exclusive corner — five-star suites, rituals and private waters." },
  { id: "hs-blue-lagoon-premium", name: "The Blue Lagoon (premium access)", area: "reykjavik", blurb: "Iceland's iconic milky-blue lagoon, with the premium extras included." },
  { id: "hs-sky-lagoon", name: "The Sky Lagoon", area: "reykjavik", blurb: "An ocean-edge infinity lagoon with the seven-step ritual, minutes from downtown." },
  { id: "hs-reykjabod", name: "Reykjaböð Hotsprings", area: "reykjavik", blurb: "A locals' favourite soak just outside the city, far from the crowds." },
  // South Coast
  { id: "hs-reykjadalur", name: "Reykjadalur Hotsprings", area: "south", blurb: "Hike the steaming valley, then bathe in a naturally hot river." },
  { id: "hs-laugaras", name: "Laugarás Hotsprings", area: "south", blurb: "The Golden Circle's new boutique lagoon between the geysers and the falls." },
  { id: "hs-secret-lagoon", name: "The Secret Lagoon", area: "south", blurb: "Iceland's oldest pool, ringed by bubbling springs and a tiny geyser." },
  { id: "hs-fontana", name: "The Fontana Lagoon", area: "south", blurb: "Steam baths and warm pools right on the shore of lake Laugarvatn." },
  { id: "hs-hraunalaug", name: "Hraunalaug", area: "south", blurb: "A tiny stone pool hidden by a farm — the definition of a secret soak." },
  // West Iceland
  { id: "hs-hvammsvik", name: "Hvammsvík", area: "west", blurb: "Eight natural oceanside pools where the tide meets geothermal water." },
  { id: "hs-giljabod", name: "Giljaböð (Húsafell Canyon)", area: "west", blurb: "Secluded canyon baths tucked into the Húsafell wilderness." },
  { id: "hs-krauma", name: "Krauma", area: "west", blurb: "Sleek designer baths fed by Europe's most powerful hot spring." },
  // Snæfellsnes
  { id: "hs-lysuholl", name: "Lýsuhóll Pool", area: "snaefellsnes", blurb: "A countryside mineral pool with horses grazing and glacier views." },
  { id: "hs-landbrotalaug", name: "Landbrotalaug", area: "snaefellsnes", blurb: "A tiny pot of warm water hidden in the lava — fits two, maybe three." },
  // The Westfjords
  { id: "hs-hellulaug", name: "Hellulaug", area: "westfjords", blurb: "A natural rock pool right on the beach, facing the open fjord." },
  { id: "hs-reykjafjordur", name: "Reykjafjörður Pool", area: "westfjords", blurb: "A remote geothermal pool above an empty fjord, far from everything." },
  { id: "hs-drangsnes", name: "Drangsnes Hot Tubs", area: "westfjords", blurb: "Three seaside hot tubs in a fishing village, free under the open sky." },
  { id: "hs-krossneslaug", name: "Krossneslaug", area: "westfjords", blurb: "A 1950s pool at the end of the road, waves breaking just past the edge." },
  // The North
  { id: "hs-grettislaug", name: "Grettislaug", area: "north", blurb: "Soak where the saga outlaw Grettir warmed himself a thousand years ago." },
  { id: "hs-geosea", name: "GeoSea Húsavík", area: "north", blurb: "Clifftop infinity pools of warm seawater overlooking the whale bay." },
  { id: "hs-forest-lagoon", name: "Forest Lagoon", area: "north", blurb: "A birch-forest lagoon hidden in the hills above Akureyri." },
  { id: "hs-myvatn", name: "Mývatn Nature Baths", area: "north", blurb: "Milky-blue bathing in the volcanic north — the north's Blue Lagoon." },
  { id: "hs-hofsos", name: "Hofsós Pool", area: "north", blurb: "A hillside infinity pool that seems to pour straight into the fjord." },
  // East Fjords
  { id: "hs-vok", name: "Vök Baths", area: "east", blurb: "Floating infinity pools on a lake, warmed by springs beneath the water." },
];

// Private day tours — all depart from Reykjavik
export const REYKJAVIK_TOURS = [
  {
    id: "x-goldencircle",
    name: "The Golden Circle Tour",
    tag: "Private",
    desc: "Þingvellir, Geysir and Gullfoss — the classic trio without the crowds, privately guided.",
    image: "/assets/catalogue/strokkur-geysir.jpg",
  },
  {
    id: "t-southcoast",
    name: "The South Coast Tour",
    tag: "Private",
    desc: "Seljalandsfoss, Skógafoss, the DC-3 airplane wreck, Dyrhólaey and Reynisfjara black beach.",
    image: "/assets/catalogue/south-coast.jpg",
  },
  {
    id: "t-snaefellsnes",
    name: "Snæfellsnes Peninsula",
    tag: "Private",
    desc: "Snæfellsjökull glacier, Búðir black church, Kirkjufell and more — Iceland in miniature.",
    image: "/assets/catalogue/kirkjufell.jpg",
  },
  {
    id: "t-westislands",
    name: "The Westman Islands Tour",
    tag: "Private",
    desc: "The RIB safari, Elephant Rock, Herjólfsdalur, the black church, the volcano and the volcano museum.",
    image: "/assets/catalogue/west-islands.jpg",
  },
  {
    id: "t-langjokull",
    name: "Langjökull Glacier",
    tag: "Private",
    desc: "Into the Glacier, Reykholt, Hraunfossar, Deildartunguhver, Víðgelmir lava cave and Húsafell Canyon Baths.",
    image: "/assets/catalogue/into-glacier.jpg",
  },
  {
    id: "t-highlands",
    name: "The Highlands",
    tag: "Private",
    desc: "Iceland's raw interior — rhyolite mountains, hidden hot springs and tracks only super-jeeps know.",
    image: "/assets/catalogue/highlands.jpg",
  },
];

// Activities — all depart from Reykjavik
export const REYKJAVIK_ACTIVITIES = [
  {
    id: "x-spas",
    name: "Spa & Wellness Retreats",
    tag: "Restore",
    desc: "Sky Lagoon rituals, Blue Lagoon in-water massages and private geothermal spa days.",
    image: "/assets/catalogue/lagoon-massage.jpg",
  },
  {
    id: "x-whales",
    name: "Whale Watching & Puffin Tours and Charters",
    tag: "Wildlife",
    desc: "Private RIB boats from Reykjavik's old harbour — whales, puffins and midnight-sun crossings.",
    image: "/assets/catalogue/whales-puffins.jpg",
  },
  {
    id: "x-glacierhike",
    name: "Glacier Hikes",
    tag: "Ice",
    desc: "Crampons and ropes across Mýrdalsjökull or Vatnajökull with elite mountain guides.",
    image: "/assets/catalogue/glacier-hike.jpg",
  },
  {
    id: "a-glacierclimb",
    name: "Glacier Climbing",
    tag: "Ice",
    desc: "Vertical blue-ice walls, technical axes and guides who read the glacier like a map.",
    image: "/assets/catalogue/ice-climbing.jpg",
  },
  {
    id: "x-horses",
    name: "Icelandic Horse Riding",
    tag: "Heritage",
    desc: "Tölt across lava fields and black beaches on the island's beloved purebred horses.",
    image: P(3591560),
  },
  {
    id: "x-silfra",
    name: "Silfra Fissure Diving or Snorkeling",
    tag: "Depths",
    desc: "Snorkel or dive between two tectonic plates in the clearest water on Earth.",
    image: "/assets/catalogue/silfra-dive.jpg",
  },
  {
    id: "a-riverrafting",
    name: "River Rafting",
    tag: "Rapids",
    desc: "White-water runs down glacial rivers — full gear, expert guides and a hot shower after.",
    image: "/assets/catalogue/river-rafting.jpg",
  },
  {
    id: "a-flyfishing",
    name: "Fly Fishing",
    tag: "River",
    desc: "Atlantic salmon and arctic char on private stretches of Iceland's clearest rivers.",
    image: "/assets/catalogue/fly-fishing.jpg",
  },
  {
    id: "x-foodtours",
    name: "Reykjavik Food & Bar Tours",
    tag: "Taste",
    desc: "Hosted walks through the city's best kitchens, craft bars and hidden dining rooms.",
    image: U("photo-1414235077428-338989a2e8c0"),
  },
  {
    id: "x-northernlights",
    name: "Northern Lights Hunts",
    tag: "Aurora",
    desc: "Cloud-dodging aurora chases with photographers, hot drinks and heated super-jeeps.",
    image: U("photo-1483347756197-71ef80e95f73"),
  },
];

// Other areas in Iceland — multi-day private tours
export const OTHER_AREAS_TOURS = [
  {
    id: "o-ringroad",
    name: "The Ring Road",
    tag: "Multi-Day",
    desc: "5 days, 7 days, 10 days or fully custom — the complete circle around Iceland.",
    image: "/assets/catalogue/ring-road.jpg",
  },
  {
    id: "o-glacierlagoon",
    name: "The Glacier Lagoon Tour",
    tag: "Multi-Day",
    desc: "Ice caves, Fjarðarárgljúfur canyon, Svartifoss and the Viking Village.",
    image: "/assets/catalogue/glacier-lagoon.jpg",
  },
  {
    id: "o-westfjords",
    name: "The Westfjords",
    tag: "Multi-Day",
    desc: "Dynjandi waterfall, Látrabjarg cliffs, Rauðisandur, Hellulaug and the Arctic Fox Center.",
    image: "/assets/catalogue/westfjords.jpg",
  },
  {
    id: "o-north",
    name: "The North",
    tag: "Multi-Day",
    desc: "Akureyri, Goðafoss, Mývatn Nature Baths, Siglufjörður, Ásbyrgi Canyon, Húsavík, Dettifoss and Grjótagjá.",
    image: "/assets/catalogue/north-iceland.jpg",
  },
  {
    id: "o-eastfjords",
    name: "The East Fjords",
    tag: "Multi-Day",
    desc: "Stuðlagil Canyon, Egilsstaðir, Mjóifjörður, Djúpivogur and Hengifoss.",
    image: "/assets/catalogue/east-fjords.jpg",
  },
];

// Other areas in Iceland — activities
export const OTHER_AREAS_ACTIVITIES = [
  {
    id: "oa-hotsprings",
    name: "Geothermal Hot Springs",
    tag: "Ritual",
    desc: "Twenty springs beyond the capital — from GeoSea in the north to Krossneslaug in the Westfjords. Pick as many as you like.",
    image: "/assets/catalogue/natural-hot-spring.jpg",
  },
  {
    id: "oa-zodiac",
    name: "Zodiac Boat Tour",
    tag: "Adventure",
    desc: "Fast RIB runs between the icebergs — closer to the ice than any other boat gets.",
    image: "/assets/catalogue/zodiac-boat.jpg",
  },
  {
    id: "oa-amphibian",
    name: "Amphibian Boat Tour",
    tag: "Adventure",
    desc: "Drive straight from land into the glacier lagoon aboard the big wheeled boats.",
    image: "/assets/catalogue/amphibian-boat.jpg",
  },
  {
    id: "oa-kayaking",
    name: "Kayaking",
    tag: "Adventure",
    desc: "Paddle between icebergs on a glacier lagoon or along silent fjord shores far from the roads.",
    image: "/assets/catalogue/kayaking.jpg",
  },
  {
    id: "oa-icecaves",
    name: "Vatnajökull Ice Caves",
    tag: "Ice",
    desc: "Crystal-blue natural ice caves beneath Europe's largest glacier — winter only.",
    image: "/assets/catalogue/vatnajokull-ice-cave.jpg",
  },
  {
    id: "oa-snowmobile",
    name: "Snowmobile Tour on a Glacier",
    tag: "Action",
    desc: "Full-throttle runs across the ice cap — guides, heated gear and summit photo stops.",
    image: P(804569),
  },
  {
    id: "oa-fatbike",
    name: "Fat Bike Tour",
    tag: "Action",
    desc: "Huge-tired bikes across black sand beaches and highland trails — silent and surreal.",
    image: "/assets/catalogue/fat-bike.jpg",
  },
];

export const BASIC_OPTIONS = [
  { id: "basic-hotel", name: "Hotels & Stays", tag: "Essential", desc: "The finest suites and private addresses the destination offers.", image: "https://images.ctfassets.net/w65k7w0nsb8q/2L6UyboQzM26lViMRD2R0X/15da35923923965cbe8996f2af785f0c/The_Retreat.jpg?w=1600&q=75&fm=jpg" },
  { id: "basic-transport", name: "Transport & Transfers", tag: "Seamless", desc: "Chauffeured cars, airport meet-and-greet and drivers on call.", image: U("photo-1449965408869-eaa3f722e40d") },
  { id: "basic-activities", name: "Activities & Adventures", tag: "Action", desc: "Signature local adventures, arranged privately for your party.", image: P(804569) },
  { id: "basic-tours", name: "Private Tours", tag: "Explore", desc: "The must-sees with expert private guides, on your schedule.", image: U("photo-1504893524553-b855bce32c67") },
  { id: "basic-dinner", name: "Dinners & Fine Dining", tag: "Palate", desc: "The right table at the right restaurant, every night.", image: U("photo-1414235077428-338989a2e8c0") },
  { id: "basic-nightlife", name: "Nightlife & Evening Plans", tag: "After Dark", desc: "Hosted nights out — the best rooms, the right tables.", image: U("photo-1516450360452-9312f5e86fc7") },
  { id: "basic-events", name: "Private Events", tag: "Occasion", desc: "Celebrations, proposals and gatherings staged anywhere.", image: U("photo-1533174072545-7a4b6ad7a6c3") },
];

export const BUDGET_OPTIONS = [
  { id: "b-4star", name: "Four-Star Hotels in Iceland", tag: "Smart", desc: "Hand-picked four-star stays and stylish apartments — comfort without the five-star rate.", image: "/assets/budget/four-star-hotel.jpg" },
  { id: "b-rental", name: "Rental Cars & 4x4s", tag: "Drive", desc: "From city cars to highland-ready 4x4s, insured and delivered to your door.", image: "/assets/budget/rental-4x4.jpg" },
  { id: "b-rv", name: "RVs & Campervans", tag: "Roam", desc: "Fully equipped campers for the Ring Road — freedom with a bed and a stove.", image: "/assets/budget/campervan.jpg" },
  { id: "b-guesthouses", name: "Guesthouses & Farm Stays", tag: "Local", desc: "Warm family-run guesthouses and countryside farms with real Icelandic breakfasts.", image: "/assets/budget/guesthouse.jpg" },
  { id: "b-grouptours", name: "Small-Group Tours", tag: "Together", desc: "Golden Circle, south coast and aurora tours in small, friendly groups.", image: "/assets/budget/group-tour.jpg" },
  { id: "b-selfdrive", name: "Self-Drive Packages", tag: "Freedom", desc: "Car, stays and a mapped route bundled — you just turn the key.", image: "/assets/budget/self-drive.jpg" },
];

export const AI_IMAGE_POOL = [
  U("photo-1503376780353-7e6692767b70"),
  U("photo-1540962351504-03099e0a754b"),
  U("photo-1613490493576-7fde63acd811"),
  U("photo-1573843981267-be1999ff37cd"),
  U("photo-1548574505-5e239809ee19"),
  U("photo-1511795409834-ef04bbd61622"),
];

export const COUNTRIES = [
  "Iceland", "Norway", "Sweden", "Denmark", "Finland", "Scotland", "Ireland", "United Kingdom",
  "Switzerland", "France", "Italy", "Spain", "Portugal", "Greece", "Croatia", "Monaco",
  "Austria", "Germany", "Netherlands", "Japan", "United Arab Emirates", "Maldives",
  "United States", "Canada", "Mexico", "Costa Rica", "Morocco", "South Africa",
  "Thailand", "Indonesia (Bali)", "New Zealand", "Australia", "Somewhere else",
];

export const resolveServices = (ids, extra = []) => {
  const all = [...SERVICES, ...HOT_SPRINGS, ...REYKJAVIK_TOURS, ...REYKJAVIK_ACTIVITIES, ...OTHER_AREAS_TOURS, ...OTHER_AREAS_ACTIVITIES, ...BASIC_OPTIONS, ...BUDGET_OPTIONS, ...extra];
  return ids.map((id) => all.find((s) => s.id === id)).filter(Boolean);
};
